import { render } from "./CardNew.vue?vue&type=template&id=dcd59c46&scoped=true"
import script from "./CardNew.vue?vue&type=script&lang=js"
export * from "./CardNew.vue?vue&type=script&lang=js"

import "./CardNew.vue?vue&type=style&index=0&id=dcd59c46&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd59c46"]])

export default __exports__